import React from 'react';

const DOM_HTML = () => {
  return (
    <div >
      <h1>DOM_HTML</h1>
      <p>Placeholder component for: "DOM HTML"</p>
    </div>
  );
};

export default DOM_HTML;
